import React from 'react'

export default function RightInfoIcons() {
  return (
    <>
                <div className="fbd_fields_ad mt-3">
              <div className="d-flex align-items-center justify-content-start">
                <div className='me-2'>
                  <img 
                    src='https://cdn-icons-png.flaticon.com/128/3967/3967544.png' 
                    alt=''
                  />
                </div>
                <div className='rt_title'>Trusted by thousands of travelers</div>
              </div>
            </div>

             <div className="fbd_fields_ad mt-3">
              <div className="d-flex align-items-center justify-content-start">
                <div className='me-2'>
                  <img 
                    src='https://cdn-icons-png.flaticon.com/128/9751/9751084.png' 
                    alt=''
                  />
                </div>
                <div className='rt_title'>Dedicated route experts</div>
              </div>
            </div>

              <div className="fbd_fields_ad mt-3">
              <div className="d-flex align-items-center justify-content-start">
                <div className='me-2'>
                  <img 
                    src='https://cdn-icons-png.flaticon.com/128/870/870175.png' 
                    alt=''
                  />
                </div>
                <div className='rt_title'>No bots — real human support</div>
              </div>
            </div>

               <div className="fbd_fields_ad mt-3">
              <div className="d-flex align-items-center justify-content-start">
                <div className='me-2'>
                  <img 
                    src='https://cdn-icons-png.flaticon.com/128/1013/1013118.png' 
                    alt=''
                  />
                </div>
                <div className='rt_title'>Flexible Dates options</div>
              </div>
            </div>
    </>
  )
}
